/* ERRORS HANDLING */

/**
 * 
 * @returns {Boolean} Arguments syntax/validity
 */
function isComponentURIValid(componentURI){
    try{
        if(
            typeof componentURI != "string"
        ) {
            console.table({component_uri:componentURI});
            throw "componentURI : not a String";
        }
    } catch(error){
        console.warn(error);
        return false;
    }
    return true;
}

/* FUNCTIONS */

/**
 * 
 * @param {String} componentURI Component's file path.
 *     
 */
export async function loadComponent(componentURI){
    try{
        if(!isComponentURIValid(componentURI)) throw "Invalid arguments. Can't load HTML Component.";
    }
    catch(loadError){
        console.warn(loadError);
        return -1;
    }

    let responseComponent = await fetch(componentURI);
    if (!responseComponent.ok) {
        console.error(`HTTP error! status: ${responseComponent.status}`);
    }

    return await responseComponent.text();
}